import Error, { type ErrorMessage } from './Error';
import { Toggle, ToggleProps } from '../Elements/Toggle';
import { Skeleton } from '../Elements/Skeletons';
import clsx from 'clsx';

export type ToggleCheckboxInputFieldProps = ToggleProps & {
  additionalContainerClasses?: string;
  error?: ErrorMessage;
  loading?: boolean;
  hideLabel?: boolean;
};

export const ToggleCheckboxInputField = ({
  additionalContainerClasses,
  error,
  loading,
  hideLabel,
  ...props
}: ToggleCheckboxInputFieldProps) => {
  return (
    <div className={clsx('flex flex-col gap-2 w-full', additionalContainerClasses)}>
      {loading ? <Skeleton height="2rem" /> : <Toggle {...props} hideLabel={hideLabel} />}
      <Error error={error} />
    </div>
  );
};
